import axiosServices from "../utils/axios";

export const fetchCallsBlackList = async () => {
  try {
    const response = await axiosServices.get(`/callsblackList`);
    return response?.data?.data;
  } catch (error: any) {
    throw new Error(
      error?.data?.message || "Failed to fetch calls blacklist"
    );
  }
};

export const updateCallsBlackList = async (
  blacklist_id: string,
  data: {
    [key: string]: any;
    blacklist_id: string;
  }
) => {
  try {
    const response = await axiosServices.put(
      `/callsblackList/${blacklist_id}`,
      data
    );
    return response?.data?.data;
  } catch (error: any) {
    console.error("Error updating calls blacklist:", error?.message || error);
    throw new Error(
      error?.response?.data?.message || "Failed to update calls blacklist"
    );
  }
};

export const deleteCallsBlackList = async (blacklist_id: string) => {
  try {
    const response = await axiosServices.delete(
      `/callsblackList/${blacklist_id}`
    );
    return { success: response?.data?.success, blacklist_id };
  } catch (error: any) {
    throw new Error(error?.data?.message || "Faild to delete the data");
  }
};

export const addCallsBlackList = async (data: { [key: string]: any }) => {
  try {
    const response = await axiosServices.post(`/callsblackList`, data);
    return response.data.data;
  } catch (error: any) {
    throw new Error(
      error?.data?.message || "Faild to add the new call blacklist"
    );
  }
};
